<template>
  <div id="MarshallUndergraduatePrograms">
    <usc-hero :title="this.hero.title" :loResSrc="this.hero.loResSrc" :hiResSrc="this.hero.hiResSrc" :color="this.page.color"></usc-hero>
    <usc-intro :copy="this.intro"></usc-intro>
    <div class="body mb gutter-lg">
      <h2>Marshall Undergraduate Programs</h2>
      <address>
        <strong>Undergraduate Admissions</strong><br />
        Fertitta Hall 227<br />
        <a href="mailto:busadm@marshall.usc.edu" class="inline-hyperlink">busadm@marshall.usc.edu</a><br />
        (213) 740-8885
      </address>

      <address>
        <strong>Undergraduate Student Advising</strong><br />
        Fertitta Hall 201<br />
        <a href="mailto:undergrad.advising@marshall.usc.edu" class="inline-hyperlink">undergrad.advising@marshall.usc.edu</a><br />
        (213) 740-0690
      </address>

      <address>
        <strong>Undergraduate Career Services</strong><br />
        Fertitta Hall 201<br />
        <a href="mailto:ugcareers@marshall.usc.edu" class="inline-hyperlink">ugcareers@marshall.usc.edu</a><br />
        (213) 740-5705
      </address>

      <address>
        <strong>Undergraduate International Programs</strong><br />
        Fertitta Hall 201<br />
        <a href="mailto:uginternational@marshall.usc.edu" class="inline-hyperlink">uginternational@marshall.usc.edu</a><br />
        (213) 740-5705
      </address>

      <address>
        <strong>Dean, Marshall School of Business</strong><br />
        Bridge Hall 100<br />
        <a href="mailto:dean@marshall.usc.edu" class="inline-hyperlink">dean@marshall.usc.edu</a><br />
        (213) 740-6422
      </address>

      <address>
        <strong>Dean, Leventhal School of Accounting</strong><br />
        Accounting 101<br />
        <a href="mailto:lsoa_ugrad@marshall.usc.edu" class="inline-hyperlink">lsoa_ugrad@marshall.usc.edu</a><br />
        (213) 740-4838
      </address>
    </div>
   <!-- <usc-videoEmbed :frameTitle="this.video.frameTitle" :caption="this.video.caption" :videoSource="this.video.src"></usc-videoEmbed> -->
    <!-- <div class="body mb gutter-lg">
      <h3>USC Marshall Undergraduate Programs Offices</h3>
      <h4>Undergraduate Admissions</h4>
      <address>
        busadm@marshall.usc.edu<br />
        Fertitta Hall 227<br />
        Director of Undergraduate Admissions, Tiffiani Frye<br />
        Tel: (213) 740-8885<br />
        Toll Free: (800) 352-5719<br />
        Fax: (213) 740-7788
      </address>

      <h4>Undergraduate Student Advising</h4>
      <address>
        undergrad.advising@marshall.usc.edu<br />
        Fertitta Hall 201<br />
        Tel: (213) 740-0690
      </address>

      <h3>Undergraduate Career Services</h3>
      <address>
        ugcareers@marshall.usc.edu<br />
        Fertitta Hall 201<br />
        Tel: (213) 740-5705
      </address>

      <h4>Undergraduate International Programs</h4>
      <address>
        uginternational@marshall.usc.edu <br />
        Fertitta Hall 201<br />
        Tel: (213) 740-5705
      </address>

      <h4>Office of the Vice Dean</h4>
      <address>
        vicedeanrsvp@marshall.usc.edu<br />
        Fertitta Hall 201<br />
        Vice Dean for Undergraduate Programs, Tyrone Callahan
      </address>

      <h2>USC Marshall School of Business</h2>
      <p><a class="resources-link" href="https://www.marshall.usc.edu/" target="_blank">https://www.marshall.usc.edu/</a></p>

      <h4>Office of the Dean</h4>
      <address>
        dean@marshall.usc.edu<br />
        Bridge Hall 100<br />
        Dean, James G. Ellis
      </address>

      <h2>Leventhal School of Accounting</h2>
      <address>
        lsoa_ugrad@marshall.usc.edu
      </address>

      <h4>Administrative Offices</h4>
      <address>
        Accounting 101<br />
        Dean, William Holder<br />
        Assistant Dean, Mildred Penner<br />
        Tel: (213) 740-4838
      </address>
    </div>

    <div class="body mb gutter-lg">
      <h2>Other Resources</h2>
      <h3>Popular Libraries</h3>
      <h4>Accounting</h4>
      <address>
        (213) 740-5027 <br />
        Accounting 100
      </address>

      <h4>Crocker Business Library</h4>
      <address>
        (213) 740-8520<br />
        Hoffman Hall 201
      </address>

      <h4>Doheny Memorial Library</h4>
      <address>
        (213) 740-2924<br />
        DML
      </address>

      <h4>Leavey</h4>
      <address>
        (213) 740-4350<br />
        LVL
      </address>

      <h3>University-Wide Student and Administrative Services</h3>
      <h4>Admission Office</h4>
      <address>
        (213) 740-1111<br />
        TCC/JHH
      </address>

      <h4>Bookstore </h4>
      <address>
        (213) 740-5200<br />
        Bookstore
      </address>

      <h4>Campus Cruiser Escort Service </h4>
      <address>
        (213) 740-4911
      </address>

      <h4>Cashier’s Office </h4>
      <address>
        (213) 740-2877<br />
        STU
      </address>

      <h4>Department of Public Safety</h4>
      <address>
        (213) 740-6000<br />
        Parking Structure A
      </address>

      <h4>Emergencies&mdash;USC Dept. of Public Safety</h4>
      <address>
        (213) 740-4321<br />
        Parking Structure A
      </address>

      <h4>Engemann Student Health Center</h4>
      <address>
        (213) 740-9355
      </address>

      <h4>Financial Aid</h4>
      <address>
        (213) 740-1111<br />
        JHH, Lobby
      </address>

      <h4>Housing Office</h4>
      <address>
        (213) 740-2546<br />
        620 USC McCarthy Way
      </address>

      <h3>Inquiry and Payment System Billing</h3>
      <h4>Cashier’s Office </h4>
      <address>
        (213) 740-7471
      </address>

      <h4>International Admissions </h4>
      <address>
        (213) 740-7296<br />
        Trojan Hall
      </address>

      <h4>Lost and Found </h4>
      <address>
        (213) 740-9759<br />
        Parking Structure A
      </address>

      <h4>Lyon Center </h4>
      <address>
        (213) 740-5127<br />
        Lyon Center
      </address>

      <h4>Mailing Services Management</h4>
      <address>
        (213) 821-1200
      </address>

      <h4>Mail Stop </h4>
      <address>
        (213) 740-2467 <br />
        Parking Structure C (PSX)
      </address>

      <h4>Office of International Services</h4>
      <address>
        (213) 740-2666 <br />
        Student Union 300
      </address>

      <h4>Registration, USC </h4>
      <address>
        (213) 740-8500 <br />
        REG 101
      </address>

      <h4>Student Judicial Affairs and Community Standards</h4>
      <address>
        STU 206
      </address>

      <h4>Ticket Office</h4>
      <address>
        (213) 740-4672 <br />
        Student Union 100
      </address>

      <h4>Transcripts </h4>
      <address>
        (213) 740-5986 <br />
        REG Lobby
      </address>

      <h4>Transportation Office </h4>
      <address>
        (213) 740-3575 <br />
        Parking Structure X
      </address>

      <h4>Travel Services </h4>
      <address>
        (213) 254-2662 <br />
        University Gateway, Unit MM
      </address>

      <h4>University Operator </h4>
      <address>
        (213) 740-2311
      </address>

      <h4>USC Campus Tours </h4>
      <address>
        (213) 740-1111<br />
        TCC 202
      </address>

      <h4>USC Oral Health Center </h4>
      <address>
        (213) 740-2012<br />
        1031 W. 34th Street
      </address>
    </div>

    <usc-linkGroup class="mb" :title="this.linkGroups[0].title" :links="this.linkGroups[0].links"></usc-linkGroup>
    <usc-linkGroup class="mb" :title="this.linkGroups[1].title" :links="this.linkGroups[1].links"></usc-linkGroup>

    <div class="body mb gutter-lg">
      <h2>OASIS</h2>
      <p>This powerful online information tool is specifically for student use. Once you are enrolled in the program, you can check your completed course list, grades, current enrollment status, fee bill account status (including balance due and specific charges) and change your address for all USC departments.</p>
      <usc-cta text="Log in to OASIS" url="https://usc.edu/OASIS"></usc-cta>
      <p>Use your USC ID number and six-digit birth date (“mmddyy” format).</p>
    </div>

    <div class="body mb gutter-lg">
      <h2>Catalogue</h2>
      <p>The USC Catalogue is the document of authority for all students. The edition for the semester of your admission to the undergraduate program will be the reference used to ensure that you have met all USC Marshall and University requirements for graduation. Degree requirements listed in the USC Catalogue supersede any information contained in any publication of any school or department. The University reserves the right to change its policies, rules, regulations and course offerings at any time.</p>
      <usc-cta text="Read USC catalogue Now" url="http://catalogue.usc.edu/"></usc-cta>

    </div>

    <div class="body mb gutter-lg">
      <h2>SCampus</h2>
      <p>Subtitled “A Guidebook for USC Students,” SCampus contains a wealth of important information about the many services and facilities, special programs and other resources available to you on campus. The publication also outlines official policies, procedures and rights and responsibilities that govern the USC community. You will receive a copy of SCampus during orientation.</p>
    </div> -->

  </div>
</template>

<script>

import hero from '@/components/Hero'
import intro from '@/components/Intro'
import cta from '@/components/Cta'
import videoEmbed from '@/components/videoEmbed'
import linkGroup from '@/components/LinkGroup'

export default {
  name: 'MarshallUndergraduatePrograms',
  components: {
    'usc-hero': hero,
    'usc-intro': intro,
    'usc-cta': cta,
    'usc-videoEmbed': videoEmbed,
    'usc-linkGroup': linkGroup
  },
  data () {
    return {
      page: {
        color: '#ffcc00'
      },
      hero: {
        title: 'Marshall Undergraduate Programs',
        loResSrc: '../../../static/HeroImages/Marshall7.jpg',
        hiResSrc: '../../../static/HeroImages/Marshall7.jpg'
      },
      intro: [
        'USC and Marshall are here to support you every step of the way. Following is a quick reference guide to some of the key resources available to you.'
      ],
      video: {
        caption: 'Dean Ellis answers questions from students',
        src: 'https://player.vimeo.com/video/249455387?title=0&byline=0&portrait=0',
        frameTitle: 'Video: Dean Ellis answers questions'
      },
      linkGroups: {
        0: {
          title: 'Websites',
          links: [
            {
              text: 'USC',
              url: 'https://www.usc.edu/'
            },
            {
              text: 'USC Marshall',
              url: 'https://www.marshall.usc.edu/'
            }
          ]
        },
        1: {
          title: 'Helpful Web Links',
          links: [
            {
              text: 'Academic Calendar',
              url: 'https://academics.usc.edu/calendar/academic-calendar-2018-2019/'
            },
            {
              text: 'Athletics',
              url: 'http://usctrojans.com/'
            },
            {
              text: 'Bookstore',
              url: 'https://www.uscbookstore.com/'
            },
            {
              text: 'Catalogue',
              url: 'http://catalogue.usc.edu/'
            },
            {
              text: 'Class Schedule',
              url: 'http://classes.usc.edu/'
            },
            {
              text: 'Center for Black Cultural and Student Affairs',
              url: 'https://cbcsa.usc.edu/'
            },
            {
              text: 'El Centro Chicano',
              url: 'http://sait.usc.edu/elcentro/'
            },
            {
              text: 'Financial Aid',
              url: 'https://financialaid.usc.edu/'
            },
            {
              text: 'Housing',
              url: 'http://housing.usc.edu/'
            },
            {
              text: 'Marshall Mashup (Current Student Blogs)',
              url: 'http://marshallmashup.usc.edu'
            },
            {
              text: 'OASIS',
              url: 'https://usc.edu/OASIS'
            },
            {
              text: 'Orientation',
              url: 'https://orientation.usc.edu/'
            },
            {
              text: 'Recreational Sports',
              url: 'https://sait.usc.edu/recsports/'
            },
            {
              text: 'Student Health Center',
              url: 'http://engemannshc.usc.edu/'
            },
            {
              text: 'Student Organizations',
              url: 'http://campusactivities.usc.edu/'
            },
            {
              text: 'Transportation Services',
              url: 'http://transnet.usc.edu/'
            },
            {
              text: 'Undergraduate Admissions',
              url: 'http://admit.usc.edu/'
            },
            {
              text: 'Volunteer Center',
              url: 'http://campusactivities.usc.edu/'
            }
          ]
        }
      }
    }
  },
  created () {
    this.$root.setPageHeader('Resources', 'Marshall Undergraduate Programs')
  }
}
</script>
<style scoped lang="scss">
  @import '~styles/vars';
  #c5-wrapper {
    h4 {
      margin-bottom: 10px;
    }
    address {
      margin-bottom: 25px;
      font-style: normal;
    }
    .resources-link {
      color: $cBody;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/resources/MarshallUndergraduatePrograms.vue